import { makeStyles } from '@material-ui/core/styles';
import { MenuItemProps } from './types';

const useStyles = makeStyles({
  root: {
    backgroundColor: (props: MenuItemProps) => props.backgroundColor,
    color: (props: MenuItemProps) => props.color,
    '&:hover': {
      backgroundColor: (props: MenuItemProps) => props.hoverBackgroundColor,
      color: (props: MenuItemProps) => props.hoverColor
    }
  }
});

export default useStyles;
